import { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { useRole } from '../hooks/useRole';
import type { Role } from '@tellowup/db';

type RoleGuardProps =
  | { requiredRole: Role; fallback?: 'null'; children: ReactNode }
  | { requiredRole: Role[]; fallback?: 'null'; children: ReactNode }
  | { requiredRole: Role; fallback?: 'redirect'; children?: ReactNode }
  | { requiredRole: Role[]; fallback?: 'redirect'; children?: ReactNode };

export default function RoleGuard({ requiredRole, fallback = 'null', children }: RoleGuardProps) {
  const role = useRole();
  const navigate = useNavigate();

  if (role === null) return null;

  const matches = Array.isArray(requiredRole)
    ? requiredRole.includes(role)
    : role === requiredRole;

  if (!matches) {
    if (fallback === 'redirect') {
      // Navigate to technician landing — callers can override via wrapping route
      navigate('/en/technician', { replace: true });
    }
    return null;
  }

  return <>{children}</>;
}
